import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=35385aa6&scoped=true&"
import script from "./AddressItem.vue?vue&type=script&lang=js&"
export * from "./AddressItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=35385aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35385aa6",
  null
  
)

export default component.exports